import React, {PropsWithChildren} from 'react';
import {FormattedMessage} from 'react-intl';
import {FlexColumn, Label, Text, FlexRow} from '@forecast-it/design-system';

type FieldLabelProps = {optional?: boolean; labelId: string; helperTextId: string | undefined};

export const FieldLabel = ({labelId, helperTextId, optional, children}: PropsWithChildren<FieldLabelProps>): JSX.Element => (
	<FlexColumn gap={'xs'}>
		<Label>
			<FormattedMessage id={labelId} /> {optional && <FormattedMessage id="common.field_optional_label" />}
		</Label>
		{!!helperTextId && (
			<Text color={Text.Color.medium}>
				<FormattedMessage id={helperTextId} />
			</Text>
		)}
		{children}
	</FlexColumn>
);

export const PlaceholderItem = ({messageId}: {messageId: string}): JSX.Element => (
	<FlexRow>
		<Text color={Text.Color.medium}>
			<FormattedMessage id={messageId} />
		</Text>
	</FlexRow>
);
